import React, { useState, useEffect } from "react";
import Socket from "../utils/socket";

const Users = props => {
  const { convos } = props;

  const [usernames, setUsernames] = useState([]);

  useEffect(() => {
    Socket.on("UPDATE_USER_LIST", users => {
      setUsernames(
        users.map(u => {
          return u.username;
        })
      );
    });
  }, []);

  return (
    <div
      style={{
        backgroundColor: "grey",
        flexGrow: 1,
        height: "100%",
        overflowY: "scroll"
      }}
    >
      <h3>USERS</h3>
      {usernames.map(e => {
        return (
          <>
            {e + " "}
            <br />
          </>
        );
      })}
    </div>
  );
};
export default Users;
